"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _joi = require("joi");

var Joi = _interopRequireWildcard(_joi);

var _types = require("../types");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var AuthProfile = Joi.object().keys({
    uid: types.uidv4.required(),
    username: Joi.string().allow(null).optional().description("Supplied unique username, this value will be used for password authentication, optional (null for users who cannot use password authentication)"),
    scope: Joi.array().items(Joi.string()).required().description("The scope (roles & permissions) of this user."),
    guildId: Joi.number(),
    canShare: Joi.boolean(),
    isActive: Joi.boolean().required()
}).label("AuthProfile").description("The user info object, providing only auth-specific / scope permission information of this user");
exports.default = AuthProfile;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ../backend/src/shared/schemas/auth/AuthProfile.ts
 ** module id = 1264
 ** module chunks = 0
 **/